import { Monitor } from 'lucide-react'

export function MobileBlocker() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 via-background to-accent/10 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-card border rounded-lg shadow-lg p-8 text-center space-y-6">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
              <Monitor className="w-10 h-10 text-primary" />
            </div>
          </div>
          
          {/* Title */}
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">
              Desktop Required
            </h1>
            <p className="text-muted-foreground">
              This application is optimized for desktop use and requires a larger screen for the best experience.
            </p>
          </div>
          
          {/* Instructions */}
          <div className="bg-muted/50 rounded-md p-4 text-sm text-muted-foreground">
            <p className="font-medium text-foreground mb-2">To access FlexKit Connect:</p>
            <ul className="space-y-1 text-left">
              <li>• Open this link on a desktop or laptop computer</li>
              <li>• Use a browser window at least 1280px wide</li>
            </ul>
          </div>
          
          {/* Logo/Branding */}
          <div className="pt-4 border-t">
            <p className="text-sm font-semibold text-primary">
              FlexKit Connect
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              Professional SMS Management
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

